import type { ReactElement } from 'react';
import type { ValuePoint } from './value-points';

interface ValuePointItemProps {
  readonly point: ValuePoint;
  /** 1부터 — 두 자리 번호로 싣는다. */
  readonly order: number;
}

/** 가치 한 칸 — 위 가는 선, 작은 번호, 굵은 제목과 설명. */
export const ValuePointItem = ({ point, order }: ValuePointItemProps): ReactElement => (
  <li className="flex flex-col gap-4 border-t border-foreground/10 pt-6">
    <span aria-hidden className="text-[13px] font-semibold text-muted-foreground tabular-nums">
      {String(order).padStart(2, '0')}
    </span>
    <h3 className="text-xl font-bold tracking-[-0.02em]">{point.title}</h3>
    <p className="text-[15px] leading-relaxed text-muted-foreground">{point.description}</p>
  </li>
);
